"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TAGS = {
    mainProduct: 'Bundler App Main Product',
    mainTrainingPantsProduct: 'Bundler App Main Training Pants Product',
};
exports.default = (function (args) {
    return {
        customerCanChooseWipeslessSizes: args ? args.customerCanChooseWipeslessSizes : false,
        discountAddOnsPerLimit: args ? args.discountAddOnsPerLimit : undefined,
        enableNighttimeDiapers: args ? args.enableNighttimeDiapers : false,
        enableTrainingPants: args ? args.enableTrainingPants : false,
        enableTrustPilotAB: args ? args.enableTrustPilotAB : false,
        futureQuantitiesDaysAhead: args === null || args === void 0 ? void 0 : args.futureQuantitiesDaysAhead,
        mainProduct: args === null || args === void 0 ? void 0 : args.products.find(function (product) { return product.tags.includes(TAGS.mainProduct); }),
        mainTrainingPantsProduct: args === null || args === void 0 ? void 0 : args.products.find(function (product) { return product.tags.includes(TAGS.mainTrainingPantsProduct); }),
        mainRcBundleProduct: args ? args.mainRcBundleProduct : undefined,
        numAddOns: args ? args.numAddOns : 1,
        numDiscountAddOns: args ? args.numDiscountAddOns : 10,
        patternGroups: args ? args.patternGroups : undefined,
        preselectedAddOns: args ? args.preselectedAddOns : undefined,
        preselectedFrequency: args ? args.preselectedFrequency : undefined,
        promotionalAddOns: (args === null || args === void 0 ? void 0 : args.promotionalCodeProducts) ? args.promotionalCodeProducts.filter(function (product) { return product.available; }) : [],
        promotionalCodeAddOnMetafields: args ? args.promotionalCodeProductsMetafields : {},
        shippingIntervalFrequencies: args ? args.shippingIntervalFrequencies.map(function (f) { return parseInt(f, 10); }) : [1],
        shippingIntervalUnitType: args ? args.shippingIntervalUnitType : 'Weeks',
        shouldHideLowStockItems: args === null || args === void 0 ? void 0 : args.shouldHideLowStockItems,
        skipSteps: args === null || args === void 0 ? void 0 : args.skipSteps,
        steps: args ? args.steps : [],
        subscriptionId: args ? args.subscriptionId : '1',
        bundlerSizesForExistingCustomersOnly: args === null || args === void 0 ? void 0 : args.bundlerSizesForExistingCustomersOnly,
        variantIdsMaxQty: args ? args.variantIdsMaxQty : undefined,
        activeSubscriber: args ? args.activeSubscriber : undefined,
        newBundleConfirmationContent: args ? args.newBundleConfirmationContent : undefined,
        newBundleConfirmationEnabled: args ? args.newBundleConfirmationEnabled : undefined,
        optimizeExperimentIds: args ? args.optimizeExperimentIds : undefined,
        rcBundlesForAcquisitionEnabled: args ? args.rcBundlesForAcquisitionEnabled : undefined,
    };
});
